import { AsyncPipe, DatePipe, NgFor, NgIf, TitleCasePipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, SimpleChange, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { ActivitiesService } from 'app/modules/admin/apps/file-manager/activities/activities.service';
import { Activity } from 'app/modules/admin/apps/file-manager/activities/activities.types';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { Item } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { DocumentService } from 'app/services/document.service';
import { Asset, activity } from 'app/models/document';
import { NgxLoadingModule } from 'ngx-loading';
import { Util } from 'app/models/util';
import { ActivityService } from 'app/services/activity.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';

@Component({
    selector       : 'activity',
    templateUrl    : './activities.component.html',
    encapsulation  : ViewEncapsulation.None,
    //changeDetection: ChangeDetectionStrategy.OnPush,
    standalone     : true,
    imports        : [NgIf, NgFor, MatIconModule, MatTooltipModule, NgxLoadingModule, RouterLink, AsyncPipe, TitleCasePipe, DatePipe, CommonModule, FullNamePipe],
})
export class ActivitiesComponent implements OnInit
{
    activities : activity[] = [];
    isLoading : boolean = false;

    @Input() inputObj: Asset = null;
    asset : Asset = null;
    teamDecorator = {};
    assetInnerDiv:any

    /**
     * Constructor
     */
    constructor(public _activityService: ActivitiesService,
        private activityServ : ActivityService,
        public util : Util,
        public sanitizer: DomSanitizer
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if (this.inputObj && this.inputObj.id) {
            this.fetchData();
        }         
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
		for (let propName in changes) {
			let changedProp = changes[propName];
			let to = changedProp.currentValue; //JSON.stringify();
			if (changedProp.isFirstChange()) {
			} else {
				let from = JSON.stringify(changedProp.previousValue);
				if (`${propName}` == `inputObj`) {
					this.inputObj = to;
                    this.fetchData();
				}
			}
		}
	}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Returns whether the given dates are different days
     *
     * @param current
     * @param compare
     */
    isSameDay(current: string, compare: string): boolean {
        let dateNw = String(current);
        let com  = String(compare);
        return DateTime.fromISO(dateNw).hasSame(DateTime.fromISO(com), 'day');
    }

    /**
     * Get the relative format of the given date
     *
     * @param date
     */
    getRelativeFormat(date: string): string {
        return DateTime.fromISO(this.getDate(date).toISOString()).toRelativeCalendar();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    fetchData() {
        this.isLoading = true;
        this.activityServ.getActivities(this.inputObj.id).then((res)=>{
            this.activities = this.activityServ.getData(res);
            for (let i = 0; i < this.activities.length; i++) {
                console.log(this.activities[i].actionType);
            }
            this.renderTeamMembers()
            this.isLoading = false;
        }).catch((error)=>{
            this.isLoading = false;
            console.log(error);
        })
    }

    getDate(date){
        return new Date(date);
    }

    renderTeamMembers() {
        this.activities.forEach((activity:any) => {
			activity["innerDiv"] = "";

			if (activity.createdBy.profilePic) {
				activity["innerDiv"] +=`<img
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${activity.createdBy.profilePic}"
                [alt]="'Activity image'">`;
			} else {
				let name = getFullName(activity.createdBy).toUpperCase();
				const [first, last] = name.split(" ");
				this.teamDecorator[name] = (first?.substring(0, 1) || '') + (last?.substring(0, 1) || '');
				activity["innerDiv"] += ` <div class=" ${this.util.getUserColor(
					name
				)} flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full font-10">
               ${this.teamDecorator[name]}
            </div>`;
			}
        });
	}
}
